import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Fog, HomeHeader } from '@components';
import { mapping } from '../../containers/Game/assets';
import { Saved } from '@containers';

export interface StartViewProps {
  handlerClick: () => void;
}

const StyledStartView = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const HomeBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${mapping.homeBackground['1x']}) no-repeat;
  background-size: cover;
  z-index: 10;
`;

const Body = styled.div`
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 20;
`;

const Title = styled.div`
  font-size: 40px;
  line-height: 1;
  background: url(${mapping.border['1x']}) no-repeat;
  background-size: 100% 100%;
  padding: 5px 15px;
`;

const Descr = styled.div`
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
`;

export const StartView: React.FC<StartViewProps> = ({ handlerClick }) => {
  const [saved, setSaved] = useState<Saved>();

  useEffect(() => {
    const savedStr = localStorage.getItem('saved');

    if (savedStr) {
      setSaved(JSON.parse(savedStr));
    }
  }, []);

  return (
    <StyledStartView>
      <HomeHeader distance={saved?.distance || 0} score={saved?.score || 0} speed={saved?.speed || 0} />
      <HomeBackground />
      <Body>
        <Title>AI Game</Title>
        <Button handleClick={handlerClick}>Start</Button>
        <Descr>Forest run</Descr>
      </Body>
      <Fog />
    </StyledStartView>
  );
};
